import {Component} from '@angular/core';

@Component({
  selector: 'app-erm-register',
  standalone: true,
  imports: [],
  templateUrl: './erm-register.component.html',
  styleUrl: './erm-register.component.scss'
})
export class ErmRegisterComponent {

}
